<template>
	<div>
		<div class="bg-login">
			<img  src="@/core/assets/img/marketea_logo_2023_blue.svg" alt="logo" class="logo-black" @click="backWebsite"/>
		</div>
		<div class="cont" >
			<h2 class="titulo">Marketea; Your Marketing, Web Presence & Technology Solution</h2>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'infoApp',
		data () {
			return {
				urlPage: window.urlweb
			}
		},
		created(){

		},
		methods: {
			backWebsite(){
				window.open(window.urlweb, "_blank");
			}
		}
	};
</script>
<style lang="css" scoped>
.bg-login{
	margin-top: 150px;
}
.logo-black{
	width: 300px;
}
.cont h2.titulo {
	font-size: 26px;
	line-height: 32px;
	font-weight: normal;
	max-width: 480px;
	color: #555;
	margin-top: 20px;
}
@media (max-width: 1190px) {
	.bg-login{
		margin-top: 100px;
	}
}
@media (max-width: 999px) {
	.bg-login{
		margin-top: 10px;
		text-align: center;
	}
	.logo-black{
	}
	.cont h2.titulo {
		text-align: center;
		margin: 10px auto;
		max-width: 400px;
		margin-top: 20px;
	}
}
@media (max-width: 767px) {
	.bg-login{
		margin-top: 10px;
		text-align: center;
	}
	.logo-black{
		width: 200px;
	}
	.cont h2.titulo {
		font-size: 20px;
		line-height: 1.5;
		text-align: center;
		max-width: 360px;
		margin: 10px auto;
	}
}
</style>
